module.exports = __webpack_public_path__ + "img/02.a677bfcd.png";